import { useState, useEffect, useContext } from 'react'
import {ListContext} from "../../context/list/list.context";
import {LookupApi} from "../../api";

export const useLookup = (isPreloaded: boolean = true) => {
    const { lookupListContext, setLookupListContext } = useContext(ListContext);

    const [lookupList, setLookupList] = useState<any>([]);
    const [loadingLookupList, setLoadingLookupList] = useState<boolean>(false);

    useEffect(() => {
        if (isPreloaded && lookupListContext.length) {
            setLookupList(lookupListContext);
        }
        else {
            loadLooKupList();
        }
    }, []);

    const loadLooKupList = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoadingLookupList(true);
            const payload = {
                '$select': 'id,type,key,value_en,value_bn,is_default,organization_ids,sort_order,status',
                '$orderby': 'sort_order asc',
            }
            LookupApi.dropdown(payload)
                .then(res => {
                    prepareListData(res.data.data.results);
                    resolve(res.data.data);
                })
                .catch(err => {
                    reject(err);
                })
                .finally(() => {
                    setLoadingLookupList(false);
                });
        });
    }

    const prepareListData = (list: any) => {
        setLookupList(list);
        if (isPreloaded) {
            setLookupListContext(list);
        }
    }

    return { loadingLookupList, loadLooKupList, lookupList }
}